import WeaponContainer from './WeaponContainer';

export default WeaponContainer
;